function componentsCheckout() {
  // add - apply discount coupon button in cart summary
  applyDiscountCoupon();

  // quatro - change text on thank-you page
  quatroChangeTextInOrder();

  // check if mattress is in cart – if yes, add a class to body and display additional service "Stress-Free Mattress Exchange"
  if (shopName === 'wsk' || shopName === 'jam' || shopName === 'dpc') {
    if($('body').hasClass('in-kosik')) {
      handleMattressInCart();
    }
  }

  if ($('body').hasClass('in-krok-1') || $('body').hasClass('in-lepes-1') || $('body').hasClass('in-comanda-plata-si-transport') || $('body').hasClass('in-step-1')) {
    // calculate weight and change position of tooltiptext - in 1st step of checkout
    calculateWeightToolTip();
    // hide Google Pay on iOS devices & safari browser
    hideGooglePay();
  }

  // age notice for newsletter and registration - in the 2nd step of checkout
  registrationNewsletterAgeNotice();
}

function applyDiscountCoupon() {
  if($('.cart-summary .extras-wrapper').length){
    // if exist element applied-coupon no apply function
    if ($('.cart-summary .extras-wrapper .discount-coupon .applied-coupon').length) {
      return;
    }
    var sPosition = Array.prototype.slice.call($('.extras-wrapper .extras-col'));
    var fPosition = sPosition[0],
    nItem = document.createElement('div');
    nItem.className = 'n-item';
      switch(lang) {
        case 'sk':
          nItem.textContent = 'Uplatniť zľavový kupón';
        break;
        case 'hu':
          nItem.textContent = 'Akciós kupon érvényesítése';
        break;
        case 'cs':
          nItem.textContent = 'Uplatnit slevový kupón';
        break;
        case 'ro':
          nItem.textContent = 'Aplicați un cupon de reducere';
        break;
        case 'bg':
          nItem.textContent = 'Uplatniť zľavový kupón';
        break;
        case 'hr':
          nItem.textContent = 'Iskoristiti kupon za popust';
        break;
        case 'si':
          nItem.textContent = 'Uveljaviti kodo za popust';
        break;
        case 'ua':
          nItem.textContent = 'Uplatniť zľavový kupón';
        break;
      default:
        return;
      }
  fPosition.appendChild(nItem);
  var rollD = $('.extras-col');
  rollD.find('.discount-coupon').hide();
  rollD.find('.n-item').on('click', function() {
      rollD.find('.discount-coupon').show();
      rollD.find('.n-item').hide();
    });
  }
}

function calculateWeightToolTip() {
  var weightPriceLink;
  var shippingId = 'shipping-1';
  switch(shopName) {
    case 'wsk':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'whu':
      weightPriceLink = 'https://www.wilsondo.hu/lakasba-szallitas/';
      break;
    case 'wcz':
      weightPriceLink = 'https://wilsondo.cz/vynos-tovaru/';
      shippingId = 'shipping-113';
      break;
    case 'wro':
      weightPriceLink = 'https://wilsondo.cz/vynos-tovaru/';
      shippingId = 'shipping-113';
      break;
    case 'wbg':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'whr':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'wsi':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    case 'wua':
      weightPriceLink = 'https://www.wilsondo.sk/vynos-tovaru/';
      break;
    //testovaci e-shop
    case 'test':
      weightPriceLink = 'https://627791.myshoptet.com/vynos-tovaru/';
      shippingId = 'shipping-72';
      break;
    case 'dpc':
      weightPriceLink = 'https://www.detskapostel.com/doprava-a-platba/#links-3';
      break;
    case 'mee':
      weightPriceLink = 'https://www.matrac-es-en.hu/szallitas-fizetes/#links-2';
      shippingId = 'shipping-6';
      break;
    case 'jam':
      weightPriceLink = 'https://www.ja-a-matrac.sk/doprava--platba--vynos/#links-3';
      shippingId = 'shipping-6';
      break;
    case 'eag':
      weightPriceLink = 'https://www.emeletes-agyak.hu/szallitas-fizetes-felvitel/#links-2';
      shippingId = 'shipping-6';
      break;
    case 'pos':
      weightPriceLink = 'https://www.poschodovky.sk/doprava-a-platba/#links-3';
      shippingId = 'shipping-6';
      break;
    default:
      return;
    }

  function fToolTipTextMove(pNode) {
    var myToolTip = pNode.find('label span.question-tooltip');
    var myToolTipText = myToolTip.attr('title');
    // calculate weight
    if (pNode.attr('id') === shippingId) {
      var totalWeight = 0;
      if (dataLayer && dataLayer[0] && dataLayer[0].shoptet && dataLayer[0].shoptet.cart) {
        dataLayer[0].shoptet.cart.forEach(function (item) {
        totalWeight = totalWeight + item.quantity * item.weight;
      });
      if (totalWeight > 0) {
        totalWeight = Math.round(totalWeight * 100) / 100;
      }
      switch(lang) {
        case 'sk':
          myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>. <br />Šofér vám BEZPLATNE pomôže vyložiť tovar až k prvým uzamýkateľným dverám. Ak máte záujem aj o výnos, pozrite si prosím <a class="zasilkovna-name" href="' + weightPriceLink + '">podmienky výnosu tovaru</a>.</div>';
          break;
        case 'hu':
          myToolTipText = myToolTipText + '<div>A rendelés összsúlya: <strong>' + totalWeight + '&nbsp;kg</strong>. <br />A sofőrünk egészen az első zárható ajtóig viszi INGYENESEN a megrendelt terméket. Amennyiben lakásba szállítást is igénybe szeretne venni, kérem tekintse meg annak feltételeit <a class="zasilkovna-name" href="' + weightPriceLink + '">ITT</a>.</div>';
          break;
        case 'cs':
          myToolTipText = myToolTipText + '<div>Celková hmotnost objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        case 'ro':
          myToolTipText = myToolTipText + '<div>Greutatea totală a comenzii: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        case 'bg':
          myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        case 'hr':
          myToolTipText = myToolTipText + '<div>Ukupna težina narudžbe: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        case 'si':
          myToolTipText = myToolTipText + '<div>Skupna teža naročila: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        case 'ua':
          myToolTipText = myToolTipText + '<div>Celková hmotnosť objednávky: <strong>' + totalWeight + '&nbsp;kg</strong>.</div>';
          break;
        default:
          return;
        }
      }
    }
    // change position tooltiptext
    $('<div class="tooltiptext">' + myToolTipText + '</div>').insertAfter($(myToolTip).closest('label'));
  }

  $('div#order-shipping-methods>div').each(function () {
    fToolTipTextMove($(this));
  });
  $('div#order-billing-methods>div').each(function () {
    fToolTipTextMove($(this));
  });
}

function registrationNewsletterAgeNotice() {
  var url = document.location.href;
  var confirmation;
  switch(lang) {
    case 'sk':
      confirmation = {
        urlCheckout: '/objednavka/krok-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    case 'hu':
      confirmation = {
        urlCheckout: '/rendeles/lepes-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Hírlevelek a 16 év feletti emberek számára!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;A regisztráció 16 év feletti emberek számára!</span>',
      }
      break;
    case 'cs':
      confirmation = {
        urlCheckout: '/objednavka/krok-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettery jsou určeny pro osoby starší než 16 let!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registrace je určena pro osoby starší než 16 let!</span>',
      }
      break;
    case 'ro':
      confirmation = {
        urlCheckout: '/comanda/comanda-informatii-despre-dvs/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Buletinele informative sunt destinate persoanelor peste 16 ani!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Înregistrarea este destinată persoanelor peste 16 ani!</span>',
      }
      break;
    case 'bg':
      confirmation = {
        urlCheckout: '/order/step-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    case 'hr':
      confirmation = {
        urlCheckout: '/order/step-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettri su namijenjene osobama starijim od 16 godina!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registracija je namijenjena osobama starijim od 16 godina!</span>',
      }
      break;
    case 'si':
      confirmation = {
        urlCheckout: '/order/step-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;E-novice so namenjene osebam, starejšim od 16 let!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registracija je namenjena osebam, starejšim od 16 let!</span>',
      }
      break;
    case 'ua':
      confirmation = {
        urlCheckout: '/order/step-2/',
      //  newsletterAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Newslettre sú určené pre osoby staršie ako 16 rokov!</span>',
        registerAgeNotice: '<span style="color: royalblue;"> &nbsp;&nbsp;Registrácia je určená pre osoby staršie ako 16 rokov!</span>',
      }
      break;
    default:
      return;
  }
  if (url.indexOf(confirmation.urlCheckout) > -1) {
  //  $('.ordering-process .co-box.co-box-additional .stay-in-touch div.form-group label[for="sendNewsletter"]').append(confirmation.newsletterAgeNotice);
    $('.ordering-process .co-box.co-box-additional .stay-in-touch div.form-group label[for="set-registration"]').append(confirmation.registerAgeNotice);
  }
}

function hideGooglePay() {
  if (window.ApplePaySession && $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').length) {
    $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
  } else if($('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').length) {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
    } else if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      $('.ordering-process').find('.payment-info .shipping-billing-name:contains("Google Pay")').parent('.payment-info').parent('.billing-name').parent().hide();
    }
  }
}

function handleMattressInCart() {
  const cartItemsCheck = getShoptetDataLayer('cart');
  if ($.isArray(cartItemsCheck) && cartItemsCheck.some(item => item.name && item.name.toLowerCase().includes("matrac"))) {
      $(document.body).addClass('mattress-in-cart');
  } else {
      $(document.body).removeClass('mattress-in-cart');
  }
}

function quatroChangeTextInOrder() {
  const recapPaymentMethod = $('.in-dakujeme .recapitulation-table td[data-testid="recapPaymentMethod"]');
  // Check if it contains the text 'Quatro Splátky'
  if (recapPaymentMethod.text().trim() === 'Quatro Splátky') {
    // Change text of title
    $('.order-summary-heading').text('Vaša objednávka čaká na vyplnenie žiadosti o splátku');
    // Change text of payment description
    $('.reca-payment-wrap p[data-testid="textAbovePayButton"]').text('Kliknite na tlačidlo nižšie a vyplňte žiadosť o splátku');
    // Change text of payment button
    $('#onlinePaymentButton').text('Kliknite a vyplňte žiadosť');
  }
}
